import { sendRequest } from "../axios";
export default {
  state: {
    newCalculation: true,
    banksCS: [],
    productsCS: [],
    customersCS: [],
    situationsCS: [],
    currentBankCS: null,
    currentProductCS: {},
    productDataCS: {},
    currentCustomerCS: null,
    currentSituationCS: null,
    purchasesCS: [],
    acraCS: [],
    raexpertCS: [],
    purchasesValCS: [],
    calcSettingsTab: 1,
    situationsWithCommentCS: [],
    situationWithCommentCS: null,
    searchCS: "",
    sortCS: "bank_license",
    sortDesc: true,
    updateProductItemsPerPage: 15,

    searchBankCS: "",
    sortBankCS: "license",
    sortBankDesc: true,
    updateBankItemsPerPage: 10,
    websites: [],
    banksTags: [],
    selectedBankTag: 1
  },
  mutations: {
    SET_BANKS_PER_PAGE_CS(state, commit) {
      state.updateBankItemsPerPage = commit;
    },
    SET_SORT_BANKS_CS(state, commit) {
      state.sortBankCS = commit;
    },
    SET_SORT_DESC_BANKS_CS(state, commit) {
      state.sortBankDesc = commit;
    },
    SET_SEARCH_BANKS_CS(state, commit) {
      state.searchBankCS = commit;
    },
    SET_PRODUCTS_PER_PAGE_CS(state, commit) {
      state.updateProductItemsPerPage = commit;
    },
    SET_SORT_CS(state, commit) {
      state.sortCS = commit;
    },
    SET_SORT_DESC_CS(state, commit) {
      state.sortDesc = commit;
    },
    SET_SEARCH_CS(state, commit) {
      state.searchCS = commit;
    },
    SET_NEW_CALCULATION(state, commit) {
      state.newCalculation = commit;
    },
    SET_CURRENT_SITUATIONSCS(state, commit) {
      state.situationsWithCommentCS = commit;
    },
    SET_CALC_SETTINGS_TAB(state, commit) {
      state.calcSettingsTab = commit;
    },
    SET_PRODUCTDATA(state, commit) {
      state.productDataCS = commit;
    },
    SET_BANKSCS(state, commit) {
      state.banksCS = commit;
    },
    SET_WEBSITES(state,commit){
      const websites = Object.assign([],commit)
      state.websites = websites.sort((a,b)=>a - b)
    },
    REMOVE_WEBSITES(state,payload){
      state.websites = state.websites.filter(item=>item.id !== payload)
    },
    ADD_WEBSITES(state,commit){
      state.websites.push(commit)
    },
    SET_PRODUCTSCS(state, commit) {
      state.productsCS = commit;
    },
    SET_CUSTOMERSCS(state, commit) {
      state.customersCS = commit;
    },
    SET_SITUATIONSCS(state, commit) {
      state.situationsCS = commit;
    },

    SET_CURRENT_BANKCS(state, commit) {
      state.currentBankCS = commit;
    },
    SET_CURRENT_PRODUCTCS(state, commit) {
      state.currentProductCS = commit;
    },
    SET_CURRENT_SITUATIONCS(state, commit) {
      state.currentSituationCS = commit;
    },
    SET_CURRENT_CUSTOMERCS(state, commit) {
      state.currentCustomerCS = commit;
    },

    SET_PURCHASESCS(state, payload) {
      state.purchasesCS = payload;
    },
    SET_ACRACS(state, payload) {
      state.acraCS = payload;
    },
    SET_RAEXPERTCS(state, payload) {
      state.raexpertCS = payload;
    },
    SET_PURCHASESVALCS(state, payload) {
      state.purchasesValCS = payload;
    },
    SET_BANKS_TAGS(state,commit){
      state.banksTags = commit
    },
    SET_SELECTED_BANK_TAG(state,commit){
      state.selectedBankTag = commit
    }
  },
  actions: {
    MAKE_BACKUP() {
      return new Promise(resolve =>
        sendRequest("api/BackupToTest", "get").then(res => {
          resolve(res.data);
        })
      );
    },
    ChangeTab({ commit }, data) {
      commit("SET_CALC_SETTINGS_TAB", data);
    },
    GetBanksTags({commit}){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/banksTags/",'get').then(
          response => {
            commit("SET_BANKS_TAGS", response.data);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    updateSituationCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/updateSituation/" + data.id, "put", data).then(
          response => {
            commit("SET_SITUATIONSCS", response.data.situations);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    removeSituationCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          "api/removeSituation/" + data.id,
          "put",
          undefined,
          reject
        ).then(response => {
          commit("SET_SITUATIONSCS", response.data.situations);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    updateCustomerCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/updateCustomer/" + data.id, "put", data).then(
          response => {
            commit("SET_CUSTOMERSCS", response.data.customers);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    updateBankCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/CalculatorBank/" + data.id, "put", data).then(
          response => {
            commit("SET_BANKSCS", response.data.bank);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    updateProductCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/CalculatorRate/" + data.id, "put", data, reject).then(
          response => {
            commit("SET_PRODUCTSCS", response.data.products);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },

    SaveNewBankCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/CalculatorBank", "post", data).then(response => {
          commit("SET_BANKSCS", response.data.bank);

          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    SaveNewProductCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/CalculatorRate", "post", data, reject).then(
          response => {
            commit("SET_PRODUCTSCS", response.data.products);
            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    SaveNewCustomerCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/addCustomer", "post", data).then(response => {
          commit("SET_CUSTOMERSCS", response.data.customers);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    SaveNewSituationCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/addSituation", "post", data).then(response => {
          commit("SET_SITUATIONSCS", response.data.situations);

          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    addBankCS({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/getBankRekvInfo", "get", undefined, reject).then(
          response => {
            //commit('SET_CURRENT_BANKCS',response.data.bank);
            commit("SET_PURCHASESCS", response.data.purchase);
            commit("SET_ACRACS", response.data.acra);
            commit("SET_RAEXPERTCS", response.data.raexpert);
            commit("SET_PURCHASESVALCS", []);

            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    addProductCS({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/getProductRekvInfo", "get", undefined, reject).then(
          response => {
            var currentProduct = [];
            var varNameArr = [
              "bank",
              "limit",
              "usn",
              "osob",
              "preview",
              "agentsup",
              "agentsdown",
              "tariff",
              "accreditation",
              "principal",
              "request",
              "bail",
              "account",
              "paper",
              "other",
              "life",
              "practice",
              "fns",
              "third",
              "edo",
              "purchase",
              "guarantee",
              "packet",
              "method",
              "time",
              "agentsfee",
              "reloadbg",
              "gar_polz_zak",
              "your_situation"
            ];
            for (var i = 0; i < varNameArr.length; i++) {
              currentProduct[varNameArr[i] + "s"] =
                response.data[varNameArr[i]];
            }

            commit("SET_PRODUCTDATA", currentProduct);

            commit("SET_PROCESSING", false);
            resolve(response);
          }
        );
      });
    },
    addCustomerCS({ commit }) {
      commit("SET_PROCESSING", true);
      commit("SET_CURRENT_CUSTOMERCS", {});
      commit("SET_PROCESSING", false);
    },
    addSituationCS({ commit }) {
      commit("SET_PROCESSING", true);
      commit("SET_CURRENT_SITUATIONCS", {});
      commit("SET_PROCESSING", false);
    },

    getProductCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          `api/CalculatorRate/${data}`,
          "get",
          undefined,
          reject
        ).then(response => {
          commit("SET_CURRENT_SITUATIONSCS", response.data.situations);
          commit("SET_CURRENT_PRODUCTCS", response.data.rate);

          const currentProduct = {
            banks: response.data.bank,
            limits: response.data.limit,
            usns: response.data.usn,
            osobs: response.data.osob,
            previews: response.data.preview,
            agentsups: response.data.agentsup,
            agentsdowns: response.data.agentsdown,
            reloadbgs: response.data.reloadbg
          };

          var varNameArr = [
            "tariff",
            "accreditation",
            "principal",
            "request",
            "bail",
            "account",
            "paper",
            "other",
            "life",
            "practice",
            "fns",
            "third",
            "edo",
            "purchase",
            "guarantee",
            "packet",
            "method",
            "time",
            "agentsfee",
            "gar_polz_zak",
            "your_situation"
          ];
          for (var i = 0; i < varNameArr.length; i++) {
            currentProduct[varNameArr[i] + "s"] = response.data[varNameArr[i]];
            if (response.data.rate[varNameArr[i]]) {
              currentProduct[varNameArr[i] + "sVal"] = response.data.rate[
                varNameArr[i]
              ]
                .split(",")
                .map(string => parseInt(string));
            } else {
              currentProduct[varNameArr[i] + "sVal"] = null;
            }
          }

          commit("SET_PRODUCTDATA", currentProduct);

          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    getBankCS({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(
          `api/CalculatorBank/${data}`,
          "get",
          undefined,
          reject
        ).then(response => {
          commit("SET_CURRENT_BANKCS", response.data.bank);
          commit("SET_PURCHASESCS", response.data.purchase);
          commit("SET_ACRACS", response.data.acra);
          commit("SET_RAEXPERTCS", response.data.raexpert);
          if (response.data.bank.list) {
            var purchaseVal = response.data.bank.list
              .split(",")
              .map(string => parseInt(string));
            commit("SET_PURCHASESVALCS", purchaseVal);
          } else {
            commit("SET_PURCHASESVALCS", []);
          }

          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    getCustomerCS({ commit }, data) {
      commit("SET_PROCESSING", true);
      commit("SET_CURRENT_CUSTOMERCS", data);
      commit("SET_PROCESSING", false);
    },
    getSituationCS({ commit }, data) {
      commit("SET_PROCESSING", true);
      commit("SET_CURRENT_SITUATIONCS", data);
      commit("SET_PROCESSING", false);
    },
    addSituationComment({commit},payload){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/addSituationComment/"+payload.id, "post",payload.formData,reject)
          .then(response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          });
      });
    },
    editSituationComment({commit},payload){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/editSituationComment/"+payload.id, "post",payload.formData,reject)
          .then(response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          });
      });
    },
    deleteSituationComment({commit},formData){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/deleteSituationComment/", "post",formData,reject)
          .then(response => {
            commit("SET_PROCESSING", false);
            resolve(response);
          });
      });
    },
    GetCalcSettingsCS({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/CalculatorSettingsSimple", "get")
          .then(response => {
            commit("SET_WEBSITES", response.data.websites)
            commit("SET_BANKSCS", response.data.banks);
            commit("SET_PRODUCTSCS", response.data.products);
            commit("SET_CUSTOMERSCS", response.data.customers);
            commit("SET_SITUATIONSCS", response.data.situations);
            commit("SET_PROCESSING", false);
            resolve(response);
          });
      });
    },

    RefreshProductsCS({ commit }) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/CalculatorProductsSimple", "get").then(response => {
          commit("SET_PRODUCTSCS", response.data.products);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    getAllWebsite({commit}){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/website", "get",).then(response => {
          commit("SET_WEBSITES", response.data);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    addWebsite({ commit },payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/website", "post",{name: payload}).then(response => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    editWebsite({commit},payload){
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest("api/website", "put",payload).then(response => {
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },
    removeWebsite({ commit },payload) {
      return new Promise((resolve, reject) => {
        commit("SET_PROCESSING", true);
        sendRequest(`api/website/${payload}`, "delete").then(response => {
          commit("REMOVE_WEBSITES", payload);
          commit("SET_PROCESSING", false);
          resolve(response);
        });
      });
    },


  },
  getters: {
    GetCalcSettingsTab: state => state.calcSettingsTab,
    getBanksCS: state => state.banksCS,
    getProductsCS: state => state.productsCS,
    getCurrentBankCS: state => state.currentBankCS,
    getProductCS: state => state.currentProductCS,
    getCurrentCustomerCS: state => state.currentCustomerCS,
    getCurrentSituationCS: state => state.currentSituationCS,
    getCustomersCS: state => state.customersCS,
    getSituationsCS: state => state.situationsCS,
    getPurchasesValCS: state => state.purchasesValCS,
    getPurchasesCS: state => state.purchasesCS,
    getAcraCS: state => state.acraCS,
    getRaExperdCS: state => state.raexpertCS,
    getProductData: state => state.productDataCS,
    getSituationsWithCommentCS: state => state.situationsWithCommentCS,
    getNewCalculation: state => state.newCalculation,

    getSortCS: state => state.sortCS,
    getSortDescCS: state => state.sortDesc,
    getSearchCS: state => state.searchCS,
    getProductItemsPerPage: state => state.updateProductItemsPerPage,

    getSortBankCS: state => state.sortBankCS,
    getSortDescBankCS: state => state.sortBankDesc,
    getSearchBankCS: state => state.searchBankCS,
    getBankPerPage: state => state.updateBankItemsPerPage,
    getWebsites: state => state.websites,
    getBanksTags: state=> state.banksTags,
    getSelectedBankTags: state=> state.selectedBankTag,
  }
};
